<template>
<!-- 工厂列表 -->
    <div>
        <el-card >
        <el-row :gutter=20>
            <el-col :span="7">
                <el-input placeholder="请输入内容" v-model="queryInfo.query" clearable @clear="getFactoryList">
                    <el-button slot="append" icon="el-icon-search" @click="queryFactoryList"></el-button>
                </el-input>
            </el-col>
            <el-col :span="4">
                <el-button type="primary" @click="addDialogOpend" size="mini">添加工厂</el-button>
            </el-col>
        </el-row>
          <el-table :header-cell-style="{'text-align':'center'}"
                    :cell-style="{'text-align':'center','padding':'0px'}"
                    :data="factoryList" border stripe>
              <el-table-column label="工厂名称" prop="name">
                  <!-- 让 admin能直接打开每个工厂管理员的界面 -->
                  <template slot-scope="scope">
                    <a :href="scope.row.name" target="_blank" class="buttonText"
                        @click="saveFactoryName(scope.row.name)">{{scope.row.name}}
                    </a>
                  </template>
              </el-table-column>
              <el-table-column label="电话号码" prop="phone"></el-table-column>
              <el-table-column label="创建时间" prop="createTime">
                <template slot-scope="scope">
                    {{scope.row.createTime | dateFormat}}
                </template>
              </el-table-column>
              <!-- <el-table-column label="管理员账号" prop="username"></el-table-column> -->
              <!-- <el-table-column label="启用状态" prop="enable">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.enable" @change="factoryStateChanged(scope.row)">
                    </el-switch>
                </template>
              </el-table-column> -->
              <el-table-column wdith="180px" label="操作">
              <template slot-scope="scope">
                  <el-tooltip effect="dark" content="修改工厂" placement="top" :enterable="false">
                  <el-button type="text" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">修改工厂</el-button>
                  </el-tooltip>
                  <!-- <el-tooltip effect="dark" content="删除工厂" placement="top" :enterable="false">
                  <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeFactoryById(scope.row.id)"></el-button>
                  </el-tooltip> -->
              </template>
              </el-table-column>
          </el-table>

          <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum"
          :page-sizes="[1,2,5,10]"
          :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
          </el-pagination>
        </el-card>

        <!-- 添加工厂的对话框 -->
        <el-dialog
          title="添加工厂"
          :visible.sync="addDialogVisible"
          width="50%"
          @close="addDialogClosed">
          <el-form :rules="addFormRules" ref="addFormRef" label-width="90px" :model="addForm">
            <el-form-item label="工厂名称" prop="factoryName">
                <el-input v-model="addForm.factoryName"></el-input>
            </el-form-item>
            <el-form-item label="电话号码" prop="phone">
                <el-input v-model="addForm.phone"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addFactory">确 定</el-button>
          </span>
        </el-dialog>

        <!-- 修改工厂的对话框 -->
        <el-dialog
          title="修改工厂"
          :visible.sync="editDialogVisible"
          width="50%"
          @close="editDialogClosed">
          <el-form :rules="editFormRules" ref="editFormRef" label-width="90px" :model="editForm">
            <el-form-item label="工厂名称" prop="name">
              <el-input v-model="editForm.name"></el-input>
            </el-form-item>
            <el-form-item label="电话号码" prop="phone">
              <el-input v-model="editForm.phone"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="editDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="editFactory">确 定</el-button>
          </span>
        </el-dialog>
    </div>
</template>
<script>
import * as api from '@/api/platform/factory/list'
export default {
  data () {
    return {
      data: {
        page: 1,
        size: 2
      },
      // 获取工厂列表的请求参数
      queryInfo: {
        // 查询关键字
        query: '',
        // 当前的页数
        pagenum: 1,
        // 当前每页显示的数量
        pagesize: 10
      },
      factoryList: [],
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      addForm: {
        // number: '',
        factoryName: '',
        phone: ''
      },
      editFromId: '',
      editForm: {},
      addFormRules: {
        factoryName: [
          { required: true, message: '请输入工厂名称', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: this.$valid.checkPhone, trigger: 'blur' }
        ]
      },
      editFormRules: {
        factoryName: [
          { required: true, message: '请输入工厂名称', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: this.$valid.checkPhone, trigger: 'blur' }
        ]
      }

    }
  },
  created () {
    this.getFactoryList()
  },

    // F5刷新时候，beforeMount()会被调用
    beforeMount () {
        // hongmj: 案2: 利用sessionStorage 保存当前页面号，F5刷新时候 能回到当前页面。
        const savedPage = window.sessionStorage.getItem('platform_FactoryList')
        // console.log('savedPage=', savedPage)

        if (savedPage !== null) {
            // 去刷新页面
            this.queryInfo.pagenum = savedPage
            // this.getFactoryList() 会产生2次请求，禁止写。
        }
    },

  methods: {
    // 启用或禁用工厂,现不支持
    factoryStateChanged(factoryInfo) {
      this.$request2({
        url: `factory/modifyState/${factoryInfo.id}`,
        method: 'POST',
        params: { state: factoryInfo.enable }
      }).then(res => {
        this.$message.success('修改工厂状态成功！')
      })
    },
    // 获取工厂列表
    getFactoryList () {
      const params = this.queryInfo
      api.getFactoryList(params).then(res => {
        this.factoryList = res.data.list
        this.total = res.data.total
      })
    },
    // 条件查询
    queryFactoryList () {
      this.queryInfo.pagenum = 1
      this.getFactoryList()
    },
    // 一页展示多少切换
    handleSizeChange (newSize) {
      // this.data.size = newSize
      this.queryInfo.pagesize = newSize
      this.getFactoryList()
    },
    // 分页切换
    handleCurrentChange (newPage) {
      // this.data.page = newPage
      this.queryInfo.pagenum = newPage
      this.getFactoryList()

      // hongmj: 案2: 利用sessionStorage 保存当前页面号，F5刷新时候 能回到当前页面。
      window.sessionStorage.setItem('platform_FactoryList', newPage)
    },
    // 监听添加工厂对话框的关闭事件
    addDialogClosed () {
      this.$refs.addFormRef.resetFields()
    },
    // 监听修改工厂对话框的关闭事件
    editDialogClosed () {
      this.$refs.editFormRef.resetFields()
    },
    // 显示添加工厂弹框
    addDialogOpend () {
      this.addDialogVisible = true
      // this.$request2({
      //   url: 'factory/getUsername',
      //   method: 'GET'
      // }).then(res => {
      //   console.log(res)
      //   if (res.status !== 200) {
      //     this.$message.error('请求账号失败！')
      //   }
      //   this.addForm.username = res.data
      // })
    },
    // 添加工厂
    addFactory () {
      this.addForm.factoryName.trim()
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        const data = this.addForm
        api.addFactory(data).then(res => {
          this.addDialogVisible = false
          this.getFactoryList()
        })
      })
    },
    // 删除工厂，现不支持
    removeFactoryById (id) {
      this.$request2({
        url: `factory/delete/${id}`,
        method: 'DELETE'
      }).then(res => {
        this.$message.success('删除工厂成功！')
        this.getFactoryList()
      })
    },
    // 修改工厂
    editFactory () {
      this.$refs.editFormRef.validate(async valid => {
        // eslint-disable-next-line no-useless-return
        if (!valid) return
        // 发起修改工厂信息的数据请求
        const data = this.editForm
        api.editFactory(data).then(res => {
          this.$message.success('修改工厂信息成功！')
          this.editDialogVisible = false
          this.getFactoryList()
        })
      })
    },
    // 显示修改工厂弹框
    showEditDialog (id) {
      this.editFromId = id
      this.editDialogVisible = true
     api.showEditDialog(id).then(res => {
        this.$message.success('查询单个工厂信息成功！')
        this.editForm = res.data
        this.editForm.id = id
      })
    },

    // 保存工厂名(就是工厂用户名)
    saveFactoryName(factoryName) {
        console.log('保存的工厂名=', factoryName)

        // hongmj: 案1: 利用store。
        this.$store.commit('adminSelectFactory/SAVE_FACTORY', factoryName)

        // hongmj: 案2 利用sessionStorage--不好使
        // window.sessionStorage.setItem('adminSelectFactoryName', factoryName)
    }

  }
}
</script>
<style lang="less" scoped>
// .el-card {
//     box-shadow: 0 1px 1px rgb(0, 0, 0, 0) !important;
// }

.el-table {
    margin-top: 15px;
    font-size: 12px;
    text-align: center;
}

.el-pagination {
    margin-top: 15px;
}

.el-cascader-panel {
    height: 200px;
}

// .el-steps {
//     margin: 15px 0;
// }

// .el-step_title {
//     font-size: 13px;
// }

// .ql-editor {
//     min-height: 300px;
// }
</style>
